import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar } from 'lucide-react';
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  const today = new Date();
  const formattedDate = new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  }).format(today);
  return <div className="bg-[#D9B15F] py-2 px-2 text-center relative z-[60] shadow-lg overflow-hidden" data-id="element-196">
      <div className="max-w-7xl mx-auto flex flex-row sm:gap-6 text-[#2C2541] text-[8px] sm:text-[10px] md:text-xs font-black uppercase tracking-wider sm:tracking-[0.2em] whitespace-nowrap pt-[0px] pb-[0px] gap-[30px] items-center justify-center" data-id="element-197">
        <div className="flex items-center gap-1.5 shrink-0" data-id="element-198">
          <Calendar className="w-2.5 h-2.5 sm:w-3 sm:h-3" data-id="element-199" />
          <span className="text-[12px]" data-id="element-200">{formattedDate}</span>
        </div>

        <div className="w-px h-3 bg-[#2C2541]/20 shrink-0" data-id="element-201" />

        <div className="flex items-center gap-1.5 shrink-0" data-id="element-202">
          <Clock className="w-2.5 h-2.5 sm:w-3 sm:h-3" data-id="element-203" />
          <span className="hidden xs:inline" data-id="element-204">La oferta termina en:</span>
          <motion.span animate={{
          opacity: [1, 0.7, 1]
        }} transition={{
          duration: 1,
          repeat: Infinity
        }} className="bg-[#2C2541] text-[#D9B15F] px-1.5 sm:px-2 py-0.5 rounded font-mono sm:text-sm text-[14px]" data-id="element-205">
            {formatTime(timeLeft)}
          </motion.span>
        </div>
      </div>
    </div>;
}